import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { Link } from "react-router-dom";

function HomePage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f2f0e4", // Cream background color
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Video Banner */}
      <Box sx={{ width: "100%", height: { xs: "300px", sm: "400px", md: "500px" }, overflow: "hidden" }}>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            transform: "scale(1.5)",
            transformOrigin: "center center",
          }}
        >
          <iframe
            src="https://player.vimeo.com/video/1102026686?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;loop=1&amp;muted=1"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            title="ad"
          />
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </Box>

      {/* Main Content with Map Background */}
      {/* <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          backgroundImage: "url('/map.png')",
          backgroundSize: "65vw",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></Box> */}
      <Box
        component="img"
        src="/mapNew.jpeg"
        alt="Neighborhood Map"
        sx={{
          width: "100%",
          height: "auto", // Maintain aspect ratio
          display: "block", // Ensure it behaves as a block element
          boxShadow: "none", // Remove any potential drop shadow
          marginTop: "1vh",
        }}
      />
    </Box>
  );
}

export default HomePage;
